import React from "react";

export default function EvaluationQuestionBoolean({ question, value, onChange, disabled }) {
    return (
        <div className="qr-options-list qr-options-list--compact">
            <label className={`qr-option-card ${value === true ? "is-selected" : ""}`}>
                <input
                    type="radio"
                    name={`evaluation-question-${question.id}`}
                    checked={value === true}
                    onChange={() => onChange(true)}
                    disabled={disabled}
                />
                <span>Oui</span>
            </label>
            <label className={`qr-option-card ${value === false ? "is-selected" : ""}`}>
                <input
                    type="radio"
                    name={`evaluation-question-${question.id}`}
                    checked={value === false}
                    onChange={() => onChange(false)}
                    disabled={disabled}
                />
                <span>Non</span>
            </label>
        </div>
    );
}
